<template>
    <div class="manual-import">
        <div class="page">
            <div class="cover"></div>
            <div class="container">
                <div class="content">
                    <h1>Import manual</h1>
                    <p>Încarcă manual fișierele cu informații de stoc de la furnizori.</p>

                    <div class="white-page">
                        <table class="table table-sm table-borderless table-striped">
                            <thead>
                                <tr>
                                    <th scope="col">Denumire furnizor</th>
                                    <th scope="col">Acțiuni</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Aliant</td>
                                    <td>
                                        <ImportUploader title="Încarcă produse și stocuri" url="/import/aliant" />
                                    </td>
                                </tr>
                                <tr>
                                    <td>AXRO</td>
                                    <td>
                                        <ImportUploader title="Încarcă produse și stocuri" url="/import/axro" />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Sovamax</td>
                                    <td>
                                        <ImportUploader title="Încarcă produse și stocuri" url="/import/sovamax" />
                                    </td>
                                </tr>
                                <tr>
                                    <td>RTsol</td>
                                    <td>
                                        <ImportUploader title="Încarcă produse și stocuri" url="/import/rtsol" />
                                    </td>
                                </tr>
                                <tr>
                                    <td>DKS.pl</td>
                                    <td>
                                        <ImportUploader title="Încarcă produse și stocuri" url="/import/dks" />
                                    </td>
                                </tr>
                                <tr>
                                    <td>DPTrade special offers</td>
                                    <td>
                                        <ImportUploader title="Încarcă produse și stocuri" url="/import/dp-trade" filename="special_offer" />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Siewert & Kau</td>
                                    <td>
                                        <ImportUploader title="Încarcă produse și stocuri" url="/import/siewert" />
                                    </td>
                                </tr>
                                <tr>
                                    <td>eParts.fr</td>
                                    <td>
                                        <ImportUploader title="Încarcă produse și stocuri" url="/import/eparts" />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ImportUploader from "./import/ImportUploader";
    export default {
        name: 'ManualImport',
        components: {ImportUploader},
        data() {
            return {
                isLoaded: false,
                errorMessage: null,

                offers: [],
            }
        },
        computed: {
        },
        watch: {

        },
        methods: {

        }
    }
</script>

<style scoped>
    .manual-import {
        flex-grow: 1;
        display: flex;
    }

    .page {
        flex-grow: 1;
        position: relative;
    }

    .cover {
        width: 100%;
        height: 264px;
        position: relative;
        background: #024A8C;
    }

    .container {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .content {
        margin-top: 60px;
        color: white;
        width: 100%;
    }

    .white-page {
        background: white;
        border-radius: 5px;
        color: black;
        padding: 25px 20px;

        margin-top: 50px;
        margin-bottom: 20px;

        -webkit-box-shadow: 0px 0px 14px 2px rgba(0, 0, 0, 0.31);
        -moz-box-shadow: 0px 0px 14px 2px rgba(0, 0, 0, 0.31);
        box-shadow: 0px 0px 14px 2px rgba(0, 0, 0, 0.31);
    }

    .white-page h1 {
        color: #024A8C;
        font-weight: 600;
    }

    .white-page h2, h3, h4, h5, h6 {
        color: #6F6F6F;
        margin-top: 10px;
    }

    h1 {
        font-size: 2rem;
    }

    h2 {
        font-size: 1.1rem;
    }

    h3 {
        font-size: 1rem;
    }

    th {
        color: #024A8C;
        font-weight: 600;
    }

    table td {
        white-space: normal;
        vertical-align: middle;
    }
</style>
